import { toApiSort } from "@/lib/utils";
import { useGetOwnershipChangePacketHistory } from "@/services";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { ocpStatus } from "../../../consts";

const useStep6 = () => {
  const {id} = useParams();
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [sorting, setSorting] = useState([{ id: "revisionDate", desc: true }]);
  
  const {data: auditHistory, isLoading: isLoadingHistory, refetch: refetchAuditHistory, isRefetching} = useGetOwnershipChangePacketHistory({
    ocpId: id as string,
    data: {
      pageNumber,
      pageSize,
      sort: toApiSort(sorting, { field: "revisionDate", direction: "DESC" }),
    }
  });

  useEffect(() => {
    refetchAuditHistory()
  }, [pageNumber, pageSize, sorting]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "revisionDate",
        header: <div>When</div>,
        accessorFn: (row: any) => row?.revisionDate ? moment(row?.revisionDate).format("MM/DD/YYYY") : "",
      },
      {
        accessorKey: "changedBy",
        header: <div>User</div>,
        accessorFn: (row: any) => String(row?.changedBy || ""),
      },
      {
        accessorKey: "revisionType",
        header: <div>Action</div>,
        accessorFn: (row: any) => (ocpStatus as any)[row?.revisionType] || "",
      },
      {
        accessorKey: "oldUserName",
        header: <div>Old-New</div>,
        accessorFn: (row: any) => row?.oldUserName && row?.newUserName ? `${row?.oldUserName || ""}-${row?.newUserName}` : "",
      },
    ],
    []
  );

  return {
    columns,
    isLoading: isLoadingHistory || isRefetching,
    auditHistory: auditHistory?.data || [],
    pageNumber,
    setPageNumber,
    pageSize,
    setPageSize,
    sorting,
    setSorting,
  };
};

export default useStep6;
